import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { QairoLogo } from "./QairoLogo";

export function DashboardLayout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  const navItems = [
    { path: "/dashboard", label: "Dashboard", icon: "D" },
    { path: "/dashboard/text", label: "Text Generator", icon: "T" },
    { path: "/dashboard/image", label: "Image Generator", icon: "I" },
    { path: "/dashboard/templates", label: "Templates", icon: "L" },
    { path: "/dashboard/schedule", label: "Schedule", icon: "C" },
    { path: "/dashboard/history", label: "History", icon: "H" },
    { path: "/dashboard/team", label: "Team", icon: "G" },
    { path: "/dashboard/api", label: "API Access", icon: "{" },
    { path: "/dashboard/affiliate", label: "Affiliate", icon: "A" },
    { path: "/dashboard/settings", label: "Settings", icon: "S" },
    { path: "/pricing", label: "Upgrade", icon: "U" }
  ];

  return (
    <div className="min-h-screen bg-[#F4F4F5] flex">
      <aside className={`${sidebarOpen ? 'w-64' : 'w-20'} bg-white border-r border-black transition-all duration-300 flex flex-col`}>
        <div className="p-4 border-b border-black flex items-center justify-between">
          {sidebarOpen ? (
            <Link to="/">
              <QairoLogo variant="light" />
            </Link>
          ) : (
            <Link to="/">
              <img src="/qairo-icon-192.png" alt="QAIRO" className="w-10 h-10" />
            </Link>
          )}
          <button onClick={() => setSidebarOpen(!sidebarOpen)} className="p-2 hover:bg-gray-100 rounded" data-testid="sidebar-toggle">
            {sidebarOpen ? "\u2190" : "\u2192"}
          </button>
        </div>
        <nav className="flex-1 p-2">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`flex items-center gap-3 p-3 mb-1 rounded-lg transition-colors ${location.pathname === item.path ? 'bg-[#0066FF] text-white' : 'hover:bg-gray-100'}`}
              data-testid={`nav-${item.label.toLowerCase().replace(' ', '-')}`}
            >
              <span className={`w-8 h-8 flex items-center justify-center font-bold text-sm rounded ${location.pathname === item.path ? 'bg-white/20' : 'bg-[#0066FF]/10 text-[#0066FF]'}`}>
                {item.icon}
              </span>
              {sidebarOpen && <span className="font-medium">{item.label}</span>}
            </Link>
          ))}
        </nav>
        <div className="p-4 border-t border-black">
          {sidebarOpen && (
            <div className="mb-4">
              <p className="text-sm font-medium truncate">{user?.name}</p>
              <p className="text-xs text-gray-500 truncate">{user?.email}</p>
            </div>
          )}
          <button onClick={handleLogout} className="w-full border border-black py-2 font-bold hover:bg-black hover:text-white transition-colors text-sm" data-testid="logout-btn">
            {sidebarOpen ? "Logout" : "X"}
          </button>
        </div>
      </aside>
      <main className="flex-1 overflow-auto">
        {children}
      </main>
    </div>
  );
}
